import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';
import { filterUndefined, keywordFilteredPack } from 'js/toolbar/filters';
import TextField from '@material-ui/core/TextField';
import React from 'react';

const basePath = window.location.href.split('#')[0];

export class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: '',
      helperText: ''
    };
  }

  filteredPage() {
    let keywords = this.state.filters.split(/\s+/);
    subCategoryActions.updateBreadCrumbs([
      { text: 'Symbology', link: '' },
      {
        text: ' > ' + keywords,
        link: '#/subcat?' + keywords.join('%20')
      }
    ]);

    let filteredPacks = JSON.parse(
      JSON.stringify(subCategoryStore.getState().symbologyJson.packs)
    ).map(p => keywordFilteredPack(p, keywords));

    filteredPacks = JSON.parse(JSON.stringify(filteredPacks)).filter(
      filterUndefined
    );

    let helperText = '';
    if (filteredPacks.length > 0) {
      window.location.href = basePath + '#/subcat?' + keywords.join('%20');
      subCategoryActions.updateFilteredPacks(filteredPacks);
    } else {
      helperText = 'No Icons Found';
    }
    this.setState({
      helperText: helperText
    });
  }

  _searchKeywords(event) {
    let keywords = event.target.value;
    this.setState({ filters: keywords });
    if (keywords.length === 0) {
      this.setState({
        helperText: ''
      });
    }
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.filteredPage();
    }
  };

  render() {
    return (
      <div className='relative'>
        <TextField
          fullWidth
          error={this.state.helperText.length > 0}
          value={this.state.filters}
          className='text-search'
          ref='textFieldSubCat'
          onChange={this._searchKeywords.bind(this)}
          placeholder='Organization Detailed'
          label='Search Icons Here'
          onKeyPress={this.handleKeyPress.bind(this)}
          helperText={this.state.helperText}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/toolbar/search.js